import { Roles } from '@/auth/enum/auth.enum';
import { AuthService } from '@/auth/service/auth.service';
import { ApprovalsService } from '@/services/approvals/approvals.service';
import { StoreState } from '@/store';
import { getCurrentUserData } from '@/store/login/selectors';
import { normalize } from '@/utils/normalizeString';
import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { actionButtonsCategories, Categorie } from './action-buttons.config';

interface CategorieWithShowStatus extends Categorie {
  show: boolean;
}

@Component({
  selector: 'app-action-buttons',
  templateUrl: './action-buttons.component.html',
  styleUrls: ['./action-buttons.component.css'],
})
export class ActionButtonsComponent implements OnInit {

  requestApproverPendingReview: number = 0;

  @Input()
  get showBannerVerification(): boolean {
    return this._showBannerVerification;
  }
  set showBannerVerification(showBannerVerification: boolean) {
    this._showBannerVerification = showBannerVerification;
    this.displayCategoryAndButtons(this.showBannerVerification);
  }
  private _showBannerVerification: boolean = false;

  categoriesAndButtons: CategorieWithShowStatus[] = [];

  constructor(
    private serviceApprover: ApprovalsService,
    private store: Store<StoreState>,
    private auth: AuthService,
  ) { }

  ngOnInit(): void {
    this.getActivitiesTask();
    this.displayCategoryAndButtons(this._showBannerVerification);
  }

  toggle(index: number) {
    this.categoriesAndButtons[index].show = !this.categoriesAndButtons[index].show;
  }

  getActivitiesTask() {
    getCurrentUserData(this.store).subscribe({
      next: ({ mdmid }) => {
        this.serviceApprover.getTotalRequestApprovalCount(mdmid)
          .subscribe((res) => {
            this.requestApproverPendingReview = res;
          });
      },
    });
  }

  displayCategoryAndButtons(showBannerVerification: boolean) {
    let filteredCategories = actionButtonsCategories.map(
      (category) => ({
        ...category,
        actionButtons: category.actionButtons.filter(({ privilege }) => this.auth.userHavePrivilege(privilege)),
      }),
    );

    filteredCategories = filteredCategories.filter((category) => category.actionButtons.length > 0);

    if (!showBannerVerification) {
      filteredCategories = filteredCategories.filter((category) => normalize(category.title) !== normalize('Verificacion'));
    }

    const approverRoles: Roles[] = [
      'DLMS_EMPLOYEE_CO',
      'DLMS_EMPLOYEE_SI',
      'DLMS_SOL_OPE_MEL',
      'DLMS_SOL_PRO_MEL',
      'DLMS_SOL_OPE_SPC',
      'DLMS_SOL_PRO_SPC',
      'DLMS_SOL_MINA_MEL',
      'DLMS_SOL_MINA_SPC',
    ];

    const ingringementManagerRoles: Roles[] = [
      'DLMS_INFRA_MEL',
      'DLMS_INFRA_SPC',
      'DLMS_FISCA_MEL',
      'DLMS_FISCA_SPC',
    ];

    const isApprover = approverRoles.some((role) => this.auth.userHaveRole(role));
    const isIngringementManagerRoles = ingringementManagerRoles.some((role) => this.auth.userHaveRole(role));

    if (isApprover) {
      const unflatedSort = filteredCategories.reduce<Categorie[][]>((resultArray, category) => {
        const newResultArray = resultArray;
        if (normalize(category.title) === normalize('Aprobacion de solicitudes')) {
          newResultArray[0][0] = category;
        }
        else if (normalize(category.title) === normalize('Verificación')) {
          newResultArray[0][1] = category;
        }
        else if (normalize(category.title) === normalize('Solicitar')) {
          newResultArray[0][2] = category;
        }
        else {
          newResultArray[1].push(category);
        }
        return newResultArray;
      }, [[], []]);

      filteredCategories = unflatedSort.flat();
      filteredCategories = filteredCategories.filter((categorie) => !!categorie);
    }

    if (isIngringementManagerRoles) {
      const unflatedSort = filteredCategories.reduce<Categorie[][]>((resultArray, category) => {
        const newResultArray = resultArray;
        if (normalize(category.title) === normalize('Infraccion')) {
          newResultArray[0][0] = category;
        }
        else if (normalize(category.title) === normalize('Verificación')) {
          newResultArray[0][1] = category;
        }
        else if (normalize(category.title) === normalize('Solicitar')) {
          newResultArray[0][2] = category;
        }
        else {
          newResultArray[1].push(category);
        }
        return newResultArray;
      }, [[], []]);

      filteredCategories = unflatedSort.flat();

      filteredCategories = filteredCategories.filter((categorie) => !!categorie);
    }

    this.categoriesAndButtons = filteredCategories.map((categorie) => ({ ...categorie, show: false }));
  }

}
